<template>
  <el-dialog width="20%"
             :visible.sync="open"
             :before-close="handleClose"
             :close-on-click-modal="false"
             :title="title">
    <el-form size="mini"
             label-width="80px"
             :model="form"
             :rules="rules"
             ref="formRefs">
      <el-form-item label="分组名称"
                    prop="custGrpName">
        <el-input v-model="form.custGrpName"></el-input>
      </el-form-item>
      <el-form-item label="分组类型"
                    prop="grpKind">
        <el-select style="width: 100%"
                   v-model="form.grpKind">
          <el-option v-for="item in fenZhuOptions"
                     :key="item.value"
                     :value="item.value"
                     :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分组描述">
        <el-input v-model="form.remark"
                  type="textarea"
                  :rows="4"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="save">{{confirmButtonText}}</el-button>
      <el-button @click="cancel">{{cancelButtonText}}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { insertApi, updateApi } from "@/api/marketing";
import { mapState } from 'vuex';
export default {
  props: {
    dialogData: Array,
  },
  data () {
    return {
      open: false,
      title: "",
      form: {},
      fenZhuOptions: [
        {
          value: 0,
          label: "公共分组",
        },
        {
          value: 1,
          label: "个人分组",
        },
      ],
      id: "",
      rules: {
        custGrpName: [
          { required: true, message: "请输入分组名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        grpKind: [
          { required: true, message: "请选择分组类型", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapState(['confirmButtonText', 'cancelButtonText'])
  },
  methods: {
    // 取消
    cancel () {
      this.open = false;
      this.form = {};
    },
    handleClose () {
      this.open = false;
    },
    save () {
      if (this.id == 1 || this.id == 2) {
        this.insertSave();
      }
      //  else if (this.id == 2) {
      //   this.$message.success("保存数据成功");
      //   this.$parent.goManualDialog(1);
      //   // this.open = false;
      // } 
      else {
        this.updateSave();
      }
    },
    insertSave () {
      this.$refs.formRefs.validate((valid) => {
        if (valid) {
          let formData = {
            custGrpName: this.form.custGrpName,
            grpKind: this.form.grpKind,
            grpMode: 2,
            remark: this.form.remark,
          };
          let insertOperation = {
            condiField: 0,
            condiOP: 0,
            value1: "",
            value2: "",
          };
          insertApi(formData, [insertOperation]).then((res) => {
            if (res.success) {
              if (this.id == 2) {
                this.$message.success("复制数据成功!");

              } else {
                this.$message.success("新增数据成功!");

              }
              this.open = false;
              this.$refs.formRefs.resetFields();
              this.$parent.searchList();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    updateSave () {
      this.$refs.formRefs.validate((valid) => {
        if (valid) {
          let updateData = {
            custGrpName: this.form.custGrpName,
            grpKind: this.form.grpKind,
            grpMode: 2,
            remark: this.form.remark,
            customerGrpID: this.$parent.lookGroundList.customerGrpID,
          };
          let updateOperation = {
            condiField: 0,
            condiOP: 0,
            customerGrpID: 0,
            value1: "",
            value2: "",
          };
          updateApi(updateData, [updateOperation]).then((res) => {
            if (res.success) {
              this.$message.success("修改数据成功!");
              this.open = false;
              this.form = {};
              this.$parent.searchList();

            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  background: #d1cda5;
}
/deep/.el-dialog__footer {
  height: 60px;
  background-color: #f2f2f2;
  text-align: center;
}
.xzBox {
  height: 100px;
  width: 100%;
  border: 1px solid #ccc;
  overflow-y: auto;
}
</style>
